
class Header {

	triggerMenu() {

		if(!this.$body.classList.contains('show-menu'))
			this.$body.classList.add('show-menu');
		else
			this.$body.classList.remove('show-menu');

	}

	constructor() {

		this.triggerMenu = this.triggerMenu.bind(this);
		this.$body = document.getElementsByTagName('body')[0];
		this.$menuBt = document.getElementById('menu-trigger');
		this.$menuBt.addEventListener('click', this.triggerMenu);

	}

}

module.exports = new Header;



/** WEBPACK FOOTER **
 ** ./layouts/header.js
 **/